import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from '../../services/global.service';

export interface InvoiceData {
  orderDetails: any;
  currencyLogo: string;
  currencyAbri: string;
  dataSource: any[];
  priceWithoutTax: number;
  tax: number;
  formattedTaxRates:string;
  logo: string;
  Address:any;
}
@Component({
  selector: 'app-restaurant-invoice-print',
  templateUrl: './restaurant-invoice-print.component.html',
  styleUrls: ['./restaurant-invoice-print.component.scss']
})
export class RestaurantInvoicePrintComponent {
  displayedColumns: string[] = ['Date','Itemname', 'Price', 'Quantity', 'Amount'];
  orderDetails: any;
  currencyLogo: string;
  currencyAbri: string;
  dataSource:any
  priceWithoutTax: number;
  tax: number;
  formattedTaxRates:string;
  logo: string;
  Address: any;
  GuestName;
  RestaurantAddress
  constructor(@Inject(MAT_DIALOG_DATA) public data: InvoiceData, private dialogRef: MatDialogRef<RestaurantInvoicePrintComponent>, private globalService: GlobalService) {
    this.orderDetails = data.orderDetails;
    this.currencyLogo = data.currencyLogo;
    this.currencyAbri = data.currencyAbri;
    this.dataSource = data.dataSource;
    this.priceWithoutTax = data.priceWithoutTax;
    this.tax = data.tax;
    this.formattedTaxRates =data.formattedTaxRates;
    this.logo = data.logo
    this.Address = data.Address;
  }
 ngOnInit(){
    this.GuestName = (this.orderDetails?.guestName?.replace(/_/g, ' ')) || 'Guest name';
    this.RestaurantAddress = this.orderDetails?.BillingAddress?.[0] || '';

  
    setTimeout(() => {
        this.globalService.showLoader = false; 
        this.dataSource = this.data.dataSource;
                
        setTimeout(() => {
        const printContents = document.getElementById('print')?.innerHTML;
        const originalContents = document.body.innerHTML;
        if (printContents) {
          document.body.innerHTML = printContents;
          window.print();
          document.body.innerHTML = originalContents;
          location.reload(); // reload back to original view
        }
      }, 500);
      }, 1000);    
 }
   getTotalCost() {
    return this.dataSource.map(t => t.Amount).reduce((acc, value) => acc + value, 0);
  }
  close(){
    this.dialogRef.close();
  }
}
